import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'act-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss'],
  providers: [
    {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ToggleButtonComponent),
        multi: true
    }
  ]
})
export class ToggleButtonComponent implements OnInit, ControlValueAccessor {
  onChange: Function;
  onTouch: Function;

  @Input() on: boolean;
  @Input() disabledSwitch: boolean;
  @Input() className: string;
  @Input() name: string;
  @Output() toggled: EventEmitter<boolean> = new EventEmitter();

  writeValue(on: boolean) {
      this.on = on
  }

  registerOnChange(onChange: Function) {
      this.onChange = onChange;
  }

  registerOnTouched(onTouch: Function) {
      this.onTouch = onTouch;
  }

  onClick() {
      this.on = !this.on;
      this.toggled.emit(this.on);
      this.onChange && this.onChange(this.on);
  }

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/toggle-button/toggle-button.component.ts